import { API_URL } from "@config";
import {
  createHttpClient,
  createFetchTransport,
  createXhrTransport,
  createErrorPlugin,
  createErrorReporterPlugin,
  HttpPlugin,
  HttpTransport,
} from "@kalodata/http";
import { reportHttpRequestError } from "./reportHttpEvent";
import { createAuthPlugin } from "./authPlugin";
import { createSlicePlugin } from "./slicePlugin";
import type { ClipHttpContext, ClipHttpMeta } from "./types";
import {
  createHttpRequestReportSuccessPlugin,
  createLegacyHeadersPlugin,
  createLegacyQueryPlugin,
  createLegacyStatusFallbackPlugin,
  createToastErrorPlugin,
  DEFAULT_CLIP_TIMEOUT_MS,
  isBusinessError,
} from "./httpPlugins";
import { createSentryPlugin } from "./sentryPlugin";

const plugins = [
  createLegacyHeadersPlugin(),
  createLegacyQueryPlugin(),
  createAuthPlugin<ClipHttpMeta, ClipHttpContext>(),
  createErrorPlugin<ClipHttpMeta, ClipHttpContext>({
    isBusinessError,
  }),
  createSlicePlugin<ClipHttpMeta, ClipHttpContext>(),
  createLegacyStatusFallbackPlugin(),
  createSentryPlugin(),
  createHttpRequestReportSuccessPlugin(),
  createErrorReporterPlugin<ClipHttpMeta, ClipHttpContext>({
    reportError: (error, context) => {
      if (!error.request) {
        error.request = context.request;
      }
      reportHttpRequestError(error, context);
    },
  }),
  createToastErrorPlugin(),
] satisfies HttpPlugin<ClipHttpMeta, ClipHttpContext>[];

const createClient = (transport: HttpTransport<ClipHttpMeta, ClipHttpContext>, defaultTimeoutMs: number) =>
  createHttpClient<ClipHttpMeta, ClipHttpContext>({
    baseUrl: API_URL,
    defaultTimeoutMs,
    transport,
    plugins,
  });

export const clipHttpClient = createClient(
  createFetchTransport<ClipHttpMeta, ClipHttpContext>(),
  DEFAULT_CLIP_TIMEOUT_MS,
);

/**
 * 用于上传视频等需要大文件传输的场景，支持上传进度条，默认超时时间 2 倍于默认超时时间
 * 常规请求，推荐使用：{@link clipHttpClient}
 */
export const clipXhrHttpClient = createClient(
  createXhrTransport<ClipHttpMeta, ClipHttpContext>(),
  DEFAULT_CLIP_TIMEOUT_MS * 2,
);
